import { Tooltip as MuiTooltip } from '@mui/material'
import { tss } from 'tss-react/mui'
import { TooltipPaddingSetting, TooltipProps, TooltipType } from './types'
import { getTooltipPopperPrimitives } from './variants/primitives'

const useStyles = tss
  .withParams<{ type: TooltipType; paddingSetting: TooltipPaddingSetting }>()
  .create(({ type, paddingSetting, theme }) => ({
    tooltipPopper: getTooltipPopperPrimitives(type, paddingSetting, theme),
  }))

export function Tooltip({
  placement = 'top',
  paddingSetting = 'default',
  PopperProps,
  type = 'primary',
  offset = 0,
  enterDelay = 800,
  // Setting arrow to true by default
  arrow = true,
  ...rest
}: TooltipProps) {
  const { classes } = useStyles({ type, paddingSetting })

  const modifiedPopperProps = {
    ...PopperProps,
    modifiers: [
      ...(PopperProps?.modifiers || []),
      {
        name: 'offset',
        options: {
          offset: [0, offset], // Adjust the 4px to your needs
        },
      },
    ],
    className: classes.tooltipPopper,
  }

  return (
    <MuiTooltip
      PopperProps={modifiedPopperProps}
      arrow={arrow}
      enterDelay={enterDelay}
      // Default placement is top
      placement={placement}
      {...rest}
    />
  )
}
